import { ArrowRight, ArrowUpRight, Globe2 } from "lucide-react";

// Flags via flagcdn.com — free, reliable PNG flag CDN.
// `eu` is used for the Schengen card (European flag).
const flag = (cc) => `https://flagcdn.com/w80/${cc}.png`;

const VISA_CARDS = [
  {
    id: "schengen",
    flag: flag("eu"),
    title: "Schengen Visa",
    body: "Travel itinerary support for Schengen visa documentation.",
  },
  {
    id: "japan",
    flag: flag("jp"),
    title: "Japan Visa",
    body: "Temporary flight reservation for Japan tourist visa applications.",
  },
  {
    id: "uae",
    flag: flag("ae"),
    title: "UAE Visa",
    body: "Useful for travel itinerary and visa planning.",
  },
  {
    id: "uk",
    flag: flag("gb"),
    title: "UK Visa",
    body: "Suitable for supporting travel documentation.",
  },
  {
    id: "singapore",
    flag: flag("sg"),
    title: "Singapore Visa",
    body: "Clean itinerary PDFs delivered quickly.",
  },
  {
    id: "onward",
    icon: Globe2, // generic globe for "any country"
    title: "Proof of onward travel",
    body: "Useful for border-entry onward journey requirements.",
  },
];

function scrollToForm(e) {
  const el = document.querySelector(".gd-card.gd-fade-up");
  if (el) {
    e.preventDefault();
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}

export default function VisaUseCases() {
  return (
    <section
      className="gd-page"
      style={{ padding: "8px 24px 72px" }}
      data-testid="visa-usecases-section"
    >
      <div style={{ textAlign: "center", maxWidth: 680, margin: "0 auto 32px" }}>
        <span className="gd-small-caps">Use cases</span>
        <h2
          style={{
            fontSize: 28,
            fontWeight: 600,
            letterSpacing: "-0.02em",
            margin: "8px 0 10px",
          }}
          data-testid="visa-usecases-title"
        >
          Popular for visa applications
        </h2>
        <p
          style={{
            color: "var(--text-muted)",
            fontSize: 15,
            margin: 0,
            lineHeight: 1.6,
            maxWidth: 580,
            marginInline: "auto",
          }}
        >
          A few of the most common scenarios where applicants use a temporary flight reservation to
          complete their documentation.
        </p>
      </div>

      <div className="gd-visa-grid" data-testid="visa-usecases-grid">
        {VISA_CARDS.map((c) => {
          const Icon = c.icon;
          return (
            <a
              key={c.id}
              href="#book"
              className="gd-visa-card"
              data-testid={`visa-card-${c.id}`}
              onClick={scrollToForm}
            >
              <div className="gd-visa-flag" aria-hidden>
                {c.flag ? (
                  <img
                    src={c.flag}
                    alt=""
                    width="36"
                    height="24"
                    style={{
                      borderRadius: 3,
                      objectFit: "cover",
                      boxShadow: "0 0 0 1px rgba(17,24,39,0.06)",
                    }}
                  />
                ) : (
                  Icon && <Icon size={22} color="#2563EB" />
                )}
              </div>
              <div>
                <div className="gd-visa-title">{c.title}</div>
                <div className="gd-visa-body">{c.body}</div>
              </div>
              <ArrowUpRight size={16} className="gd-visa-arrow" />
            </a>
          );
        })}
      </div>

      <div style={{ textAlign: "center", marginTop: 28 }}>
        <a
          href="#book"
          className="gd-btn-ghost"
          style={{ display: "inline-flex" }}
          data-testid="visa-usecases-cta"
          onClick={scrollToForm}
        >
          See country-specific guidance
          <ArrowRight size={14} />
        </a>
      </div>
    </section>
  );
}
